document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("tourForm");
  if (!form) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const firstName = document.getElementById("first_name").value;
    const lastName = document.getElementById("last_name").value;
    const email = document.getElementById("email").value;
    const phone = document.getElementById("phone").value;
    const source = document.getElementById("source").value;

    const formContainer = document.getElementById("tourFormContainer");
    const successBox = document.getElementById("tourSuccessMessage");
    const checkmark = document.querySelector(".success-check");

    // Fade-out & success animation
    formContainer.classList.add("hide-animation");

    setTimeout(() => {
      formContainer.style.display = "none";
      successBox.classList.add("active");

      checkmark.classList.remove("bounce");
      void checkmark.offsetWidth;
      checkmark.classList.add("bounce");
    }, 600);

    // 🔥 GUARANTEED delivery to Zapier using querystring parameters
    try {
      const params = new URLSearchParams({
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: phone,
        source: source
      });

      await fetch("https://hooks.zapier.com/hooks/catch/25577231/ukphot4/?" + params.toString(), {
        method: "POST",
        mode: "no-cors"
      });

    } catch (error) {
      console.error("Zapier Webhook Error:", error);
    }
  });
});
